module.exports = __webpack_public_path__ + "503df50b027515c4fe264bdc2aaef6eb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team_mobi.mp4
// module id = 475
// module chunks = 1